import { Component, ElementRef, computed, inject, signal, viewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';
import { PpcLead } from '@design-system/lead/lead';

@Component({
  selector: 'app-gallery',
  imports: [TranslatePipe, PpcEyebrow, PpcHeading, PpcLead],
  templateUrl: './gallery.html',
  styleUrl: './gallery.css',
})
export class GalleryComponent {

  private readonly translate = inject(TranslateService);

  private readonly lightbox = viewChild.required<ElementRef<HTMLDialogElement>>('lightbox');

  private readonly WIDE_TILE_COLUMNS = 3;
  /* Mosaic on a 6-column grid; every row adds up to 6. */
  private readonly TILES = [
    { file: 'kingdom', columns: 4, rows: 2 },
    { file: 'row-machine', columns: 2, rows: 2 },
    { file: 'machines', columns: 2, rows: 1 },
    { file: 'cardio', columns: 2, rows: 1 },
    { file: 'bench-press', columns: 2, rows: 1 },
    { file: 'kingdom-plates', columns: 2, rows: 1 },
    { file: 'floor-wide', columns: 4, rows: 1 },
  ];

  protected readonly active = signal(0);

  protected readonly captions = toSignal(this.translate.stream('gallery.captions'), {
    initialValue: [] as string[],
  });

  protected readonly tiles = computed(() =>
    this.TILES.map((tile, index) => ({
      ...tile,
      src: `/assets/img/${tile.file}.jpg`,
      wide: tile.columns >= this.WIDE_TILE_COLUMNS,
    })),
  );

  protected readonly count = computed(() => this.tiles().length);

  protected readonly activeTile = computed(() => this.tiles()[this.active()]);

  protected readonly activeCaption = computed(() => this.captions()[this.active()]);

  protected open(index: number) {
    this.active.set(index);
    this.lightbox().nativeElement.showModal();
  }

  protected close() {
    this.lightbox().nativeElement.close();
  }

  protected closeOnBackdrop(event: MouseEvent) {
    if (event.target === this.lightbox().nativeElement) {
      this.close();
    }
  }

  protected prev() {
    this.active.update((index) => (index - 1 + this.count()) % this.count());
  }

  protected next() {
    this.active.update((index) => (index + 1) % this.count());
  }
}
